
import { queyHtmlMoudle } from "@/api/index";
import CommonTemplate from "@/components/common-template.vue";

export default {
  scrollToTop: true,

  head() {
    return {
      title: this.productTitle + "-商城源码",
      meta: [
        {
          name: "description",
          content:
            this.productTitle +
            "商城源码,开源商城系统,在线商城,源码,小程序商城源码,B2C商城源码,B2B2C商城源码,JAVA商城源码,多商户商城源码,在线商城源码,社区团购源码,O2O商城源码,S2B2C商城源码,app商城源码",
        },
        {
          name: "keywords",
          content:
            this.productTitle +
            "栏目帮助开发者快速搭建个性化在线商城。所有商城源码均为开源源码，包含B2C商城、B2B2C商城、S2B2C商城、O2O商城、社区团购等多种商城源码",
        },
      ],
    };
  },
  components: {
    CommonTemplate,
  },
  name: "id",
  async asyncData({ params, store }) {
    const res = await queyHtmlMoudle(params.id);
    if (res.data.code === 200) {
      const navList = res.data.data || [];
      const productTitle = res.data.data[0]
        ? res.data.data[0].navigationName
        : "";
      store.commit("changeindexArr", navList);
      return {
        navList,
        productTitle, //模型页面标题
      };
    } else {
      return {
        navList: [],
        productTitle: "",
      };
    }
  },
  data() {
    return {
      headbgStatus: false, //顶部背景颜色状态
      arrs_type: [],
      news_arrs: [],
    };
  },
  mounted() {
    this.$store.commit("changeindexArr", this.navList);
  },
};
